export const mfRoutes = [
  {
    path: '/around/:slug',
    name: 'around',
    component: () => import('@/pages/aroundV2/AroundPage.vue'),
  },
];

export default mfRoutes;
